import React, { useEffect, useState } from "react";
import PasswordStrenghtMeter from "../../PasswordStrenghtMeter";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormError } from "../../../components/FormError";
import  userService  from "../../../services/User.Service";
import * as Yup from "yup";
import { Loading } from "../../Loading";
import { MessageAlert } from "../MessageAlert"
import { useNavigate } from "react-router-dom"

export function ChangePassword( { userId, onClose } ) {
  const formSchema = Yup.object().shape({
    password: Yup.string()
      .required("New password is required")
      .min(6, "Password length should be at least 6 characters"),
    confPass: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("password")], "Passwords must and should match"),
  });
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(formSchema),
  });
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [messageAlertData, setMessageAlertData] = useState({});

  const onSubmit = async function(postData) {  
    const {
      confPass,
      ...rest
    } = postData;
    setMessageAlertData({});
    setLoading(true);
    const response = await userService.updateUserPassword(rest);
    setLoading(false);
    const { 
      msg: message,
      status
    } = response;
    if(!status) {
      setMessageAlertData({
          type: 'error',
          message,
          id: "message-alert"
      })
    } else {
      setMessageAlertData({
          type: 'success',
          message: "Password changed successfully.",
          id: "message-alert"
      })
      reset('', { keepDirtyValues: true })
    }
  }

  return (
    <>
    { 
      loading? <Loading /> :'' 
    }
      <div className="row">
        <div className="col-md-12 col-lg-12">
          <div className="card payment-card ">
            <form onSubmit={handleSubmit(onSubmit)}>
              <input
                type="hidden"
                className="form-control"
                {...register("userId")}
                value={userId}
              />
              <div className="card-body pt-0">
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group mb-3  ">
                        <label htmlFor="newPassword" className={`d-block input-label ${errors.password && "error"}`}>New Password</label>
                        <input
                          type="password"
                          className="form-control"
                          {...register("password")}
                          placeholder="New Password"
                          style={{ marginBottom: "3px" }}
                          onChange={(e) => setNewPassword(e.target.value)} />
                        {errors.password && (
                          <FormError message={errors.password.message} />
                        )}
                        <div>
                          <PasswordStrenghtMeter
                            password={newPassword}
                            style={{ marginBottom: "5px" }} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 ">
                      <div className="form-group mb-3  ">
                        <label htmlFor="confPass" className={`d-block input-label ${errors.confPass && "error"}`}>Confirm Password</label>
                        <input
                          type="password"
                          id="confPass"
                          {...register("confPass")}
                          className={`input-label form-control ${errors.confPass && "error"}`}
                          placeholder="*******" />
                        {errors.confPass && (
                          <FormError message={errors.confPass.message} />
                        )}
                      </div>
                    </div>
                  </div>
              </div>
              <div className="col-12 mb-3 mx-auto  mx-2 text-right">
                <button disabled={ loading? true : false } type="submit" className="btn btn-lg btn-success">
                  Update
                </button>
                <button onClick={onClose} type="button" className="btn btn-outline-danger btn-lg mx-2">
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {
        messageAlertData.hasOwnProperty('type')? <MessageAlert {...messageAlertData} /> : ''
      }
    </>
  );
}
